{{#if loggedIn }}
    {{#if savedItems.length}}
        <h2 class="hdg hdg_4" style="text-align: center; padding-top: 40px;">Saved for Later</h2>
        <table class="project" style="margin-bottom: 100px;">
            <thead class="project-hd">
                <tr class="project-hd-accentRow">
                    <th>Saved Items</th>
                    <th></th>
                    <th style="text-align: right;">Quantity</th>
                    <th style="text-align: right;">Price</th>
                    <th></th>
                </tr>
            </thead>
            <tbody class="project-bd">
                {{#each savedItems}}
                    <tr data-item-id="{{id}}" class="orderItem {{#if companionSourceId}}orderItem_isCompanion{{/if}} {{#if pending}}orderItem_isPending{{/if}} {{#unless isValid}}orderItem_isInvalid{{/unless}}" id="saved-item-{{id}}"></tr>
                {{/each}}
            </tbody>
        </table>
    {{/if}}
{{/if}}
